import React from "react";
import EmailInstantlyForPrice from "./EmailInstantlyForPrice";
import { VariantProps } from ".";
import GetPriceByEmail from "./GetPriceByEmail";
import WhyDoWeDoThis from "./WhyWeDoThis";
import ChatLink from "./ChatLink";
import PlusShippingLevels from "../PlusShippingLevels";
import GoogleViewPrice from "../GoogleViewPrice";

const P = (props: VariantProps) => {
  const {
    itemNumber,
    showBelowMinimumAdvertisedPriceForLoggedInCustomers,
    hasWebPlusDiscountedShipping,
    allowWebPlusDiscountedShipping,
    isWebstaurantPlusEligible,
    price,
    user,
    minimumBuy,
    mustBuy,
    isGoogleView,
  } = props;
  return (
    <div className="map map-override mapP">
      {isGoogleView && (
        <GoogleViewPrice
          price={price.price}
          minimumBuy={minimumBuy}
          mustBuy={mustBuy}
        />
      )}
      <PlusShippingLevels
        hasWebPlusDiscountedShipping={hasWebPlusDiscountedShipping}
        allowWebPlusDiscountedShipping={allowWebPlusDiscountedShipping}
        isWebstaurantPlusEligible={isWebstaurantPlusEligible}
        user={user}
      />
      <EmailInstantlyForPrice
        loginOverride={showBelowMinimumAdvertisedPriceForLoggedInCustomers}
      />
      <GetPriceByEmail email={user.emailAddress} itemNumber={itemNumber} />
      {!price.hideWhyDoWeDoThis && <WhyDoWeDoThis type="contact" />}
      <p className="mapText map3">
        <ChatLink />
        &nbsp;with a Customer Service rep to receive the price!
        <br />
        Mon-Thu 8AM-8PM EST · Fri 8AM-6PM EST · Sat 9AM-4PM EST
      </p>
    </div>
  );
};

export default P;
